// extracted by mini-css-extract-plugin
export default {"discountBanner":"Vea","topheader":"Wea","navleft":"Xea","navflexelem":"Yea","navright":"Zea","fixedtop":"afa","abstop":"bfa","subdesc":"cfa","smallscreennav":"efa","nav_hidden":"ffa","cancel_link":"gfa","bottomnavcontainer":"hfa","fixedbottom":"ifa","animatedbottom":"jfa","appear-bottom":"kfa","delayedbottom":"lfa","retakebtn":"mfa","long_banner":"nfa","nofixed":"ofa"};
    if(module.hot) {
      // 1743628931630
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  